import axios from 'axios'
import { decode } from 'jsog/lib/JSOG'

const toData = response => decode(response.data)

export function getOrganization(): Promise {
  return axios.get('/bw/organization/').then(toData)
}

export function getLogo(): Promise {
  return axios.get('/bw/organization/logo').then(toData)
}

export function upsertOrganization(data): Promise {
  return axios.post(`bw/organization`, data)
}

export function upsertExtraAdmin(data): Promise {
  return axios.post(`bw/organization/extraadmin`, data)
}
  
export function deleteExtraAdmin(id, kcuid): Promise {
  return axios.delete(`bw/organization/extraadmin/${id}/${kcuid}`)
}

export function deletelogo(): Promise {
  return axios.delete(`bw/organization/deletelogo`)
}


// WEBPACK FOOTER //
// ./src/services/organization-service.js